<template>
    <header class="header">
        <router-link :to="{ name: 'home' }" class="header__logo">
            <img src="/static/img/minimax-logo@2x.png" :alt="$t('menu.title_logo')" :title="$t('menu.title_logo')" height="48px">
        </router-link>

        <language-picker class="header__language"/>

        <template>
            <a href="#" class="nav__toggle_mobile" @click="toggleMobileMenu">
                Menu
                <span class="nav__toggle_mobile__icon">
                    <transition name="fade">
                        <i class="mdi mdi-menu" v-show="!showMobileMenu"></i>
                    </transition>
                    <transition name="fade">
                        <i v-show="showMobileMenu" class="mdi mdi-close"></i>
                    </transition>
                </span>
            </a>

            <nav class="nav" :class="{ 'is-active': showMobileMenu }">
                <ul>
                    <li class="nav__item" v-if="authenticated">
                        <router-link :to="{ name: 'dashboard' }" @click.native="toggleMobileMenu" class="nav__link">{{$t('menu.dashboard')}}</router-link>
                    </li>
                    <li class="nav__item" v-if="authenticated">
                        <router-link :to="{ name: 'annualreport' }" @click.native="toggleMobileMenu" class="nav__link">{{$t('menu.annualreport')}}</router-link>
                    </li>
                    <li class="nav__item--mobile">
                        <language-picker class="header__language"/>
                    </li>
                    <li class="nav__item--mobile" v-if="authenticated">
                        <a @click="signOut" @click.native.prevent="toggleMobileMenu" class="nav__link">
                            {{$t('menu.signout')}}
                        </a>
                    </li>
                </ul>
            </nav>
        </template>
    </header>
</template>

<script>
    import Vue from 'vue';
    import {Component} from 'vue-property-decorator';
    import vMediaQuery from 'v-media-query';
    import LanguagePicker from './LanguagePicker';

    Vue.use(vMediaQuery);

    @Component({
        components: {
            LanguagePicker
        },
        watch: {
            '$mq.resize': 'hideMobileMenu',
            '$route': 'onRouteChanged',

            showMobileMenu: function (newVal) {
                const className = 'nav__mobile_open';
                if (newVal) {
                    document.body.classList.add(className);
                } else {
                    document.body.classList.remove(className);
                }
            }
        }
    })
    export default class TheHeader extends Vue {
        name = 'the-header';
        showMobileMenu = false;
        authenticated = false;

        toggleMobileMenu() {
            if (this.$mq.below(992)) {
                this.showMobileMenu = !this.showMobileMenu;
            } else {
                this.showMobileMenu = false;
            }
        }

        hideMobileMenu() {
            if (this.$mq.above(991)) {
                this.showMobileMenu = false;
            }
        }

        created() {
            this.showMobileMenu = false;
            this.onRouteChanged();
        }

        signOut() {
            console.log('[ Header ]', 'Sign out');
            this.$auth.signOut().then(() => {
                this.$router.replace({
                    name: 'sign-in'
                });
            });
        }

        onRouteChanged() {
            this.authenticated = (this.$auth.currentUser());
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/TheHeader.vue